<div class="content">
    <h1>Nutzer verschieben</h1>
    <p>Wählen Sie eine neue Gruppe für den Nutzer {{dialogData.user.mail}} aus:</p>
    <div class="select is-rounded is-fullwidth mt-3">
        <select #selection (change)="this.selectGroup(selection.value)">
            <option *ngFor="let group of dialogData.groups">{{group.userGroup.name}}</option>
        </select>
    </div>
    <div class="columns mt-3">
        <div class="column is-5">
            <a class="button back-button has-round-border" (click)="cancel()" style="border: none; display: block !important; color: white;">
                <div class="columns" style="align-items: center; justify-content: center; padding-top: 5px;">
                    <div class="column is-one-fifth">
                        <img alt="Arrow Left" src="assets/images/button/left_btn.svg">
                    </div>
                    <div class="column is-bold">
                        <p style="padding-bottom: 10px;">Abbrechen</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="column is-5 is-offset-2">
            <a class="button buy-button has-round-border" (click)="move()" style="border: none; display: block !important; color: white;">
                <div class="columns" style="align-items: center; justify-content: center; padding-top: 5px;">
                    <div class="column is-bold">
                        <p style="padding-bottom: 10px;">Verschieben</p>
                    </div>
                    <div class="column is-one-fifth" style="padding-left: 0;">
                        <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>
